/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Solver_TitleInputs */

const en_cp_solver_title = /** @type {(inputs: Cp_Solver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solver`)
};

const id_cp_solver_title = /** @type {(inputs: Cp_Solver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solver`)
};

/**
* | output |
* | --- |
* | "Problem Solver" |
*
* @param {Cp_Solver_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_solver_title = /** @type {((inputs?: Cp_Solver_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Solver_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_solver_title(inputs)
	return en_cp_solver_title(inputs)
});